import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ApplicationDocumentService, DocumentFilters, MessageService, QueryParamsService, SimpleDialogService } from 'common';
import { routerTransition } from '../../shared/animations/router.animations';
import { UserPermissionService } from '../../user/user-permission/user-permission.service';
import { DocumentsFilterService } from './document-filter.service';
import { DocumentListComponent, ApplicationDocumentListComponentData } from './document-list-base.component';

@UntilDestroy()
@Component({
    selector: 'ifb-application-document-list',
    templateUrl: './application-document-list.component.html',
    styleUrls: ['./document-list.component.scss'],
    animations: routerTransition,
    standalone: false
})
export class ApplicationDocumentListComponent extends DocumentListComponent<ApplicationDocumentService> implements OnInit {

  override data: ApplicationDocumentListComponentData = undefined;

  constructor(
    route: ActivatedRoute,
    router: Router,
    userPermissionService: UserPermissionService,
    documentService: ApplicationDocumentService,
    documentsFilterService: DocumentsFilterService,
    messageService: MessageService,
    dialog: MatDialog,
    queryParamsService: QueryParamsService,
    simpleDialogService: SimpleDialogService) {
      super(route, router, documentService, documentsFilterService, messageService, dialog, userPermissionService, queryParamsService, simpleDialogService);
  }

  override ngOnInit(): void {
    this.route.data.pipe(untilDestroyed(this))
      .subscribe((it: ApplicationDocumentListComponentData) => {
        this.data = it;
        this.dataSource.data = this.data && this.data.documentQueryResult ? this.data.documentQueryResult.values : [];
      });

    this.onInitBase('servicing-application-documents');
  }

  override filter(): void {
    this.documentsFilterService.filter(new DocumentFilters(this.queryParams), this.paginator, this.sort);
  }
}
